import React from 'react';
import Header from '../components/Header';
import content from '../data/legalContent';
import '../styles/legal.css';

// Render a block of text: newlines become paragraphs, **text** becomes bold.
function renderText(text) {
  return text.split('\n').map((line, i) => (
    <p key={i}>
      {line.split(/\*\*(.+?)\*\*/g).map((part, j) => (j % 2 ? <strong key={j}>{part}</strong> : part))}
    </p>
  ));
}

const LegalPage = ({ page }) => {
  const current = content[page];

  return (
    <div className="page page--overlay">
      <Header size="small" />

      <div className="legal-body">
        <h1>{current.title}</h1>
        {current.sections.map((section, index) => (
          <div key={index} className="legal-section">
            <h2>{section.heading}</h2>
            {section.text && renderText(section.text)}

            {section.subsections &&
              section.subsections.map((sub, subIndex) => (
                <div key={subIndex} className="legal-subsection">
                  <h3>{sub.subheading}</h3>
                  {sub.text && renderText(sub.text)}
                </div>
              ))}
          </div>
        ))}
      </div>

      <button
        type="button"
        className="back-to-top"
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      >
        Back to Top
      </button>
    </div>
  );
};

export default LegalPage;
